import React from 'react';
import { Box, Button } from '@nimbus-ds/components';
import { EmptyMessage } from '@nimbus-ds/patterns';
import { CheckCircleIcon, ExclamationCircleIcon } from '@tiendanube/icons';
import { useNavegate } from 'App/hooks';
import useTranslationOrders from '../../../../../useTranslationOrders';

interface Attributes {
  orderId: string;
  refundStatus: RefundStatus;
}

export enum RefundStatus {
  REFUNDED = 'alreadyRefunded',
  NOT_ALLOWED = 'notAllowed',
  IN_PROGRESS = 'inProgress',
}

function RefundUnavailableMessage({
  orderId,
  refundStatus,
}: Attributes): React.JSX.Element {
  const translate = useTranslationOrders();
  const t = (key: string) =>
    translate(`refund.unavailable.${refundStatus}.${key}`);
  const getIconElement = () => {
    if (
      refundStatus === RefundStatus.REFUNDED ||
      refundStatus === RefundStatus.IN_PROGRESS
    ) {
      return <CheckCircleIcon size={32} />;
    } else {
      return <ExclamationCircleIcon size={32} />;
    }
  };

  const { goTo } = useNavegate();
  const navigateTo = () => {
    if (
      refundStatus === RefundStatus.REFUNDED ||
      refundStatus === RefundStatus.IN_PROGRESS
    ) {
      goTo(`/orders/${orderId}`);
    } else {
      goTo(`/orders`);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      height="45vh"
      justifyContent="center"
    >
      <EmptyMessage
        title={t('title')}
        text={t('description')}
        icon={getIconElement()}
        actions={
          <Button appearance="primary" onClick={() => navigateTo()}>
            {t('action')}
          </Button>
        }
      />
    </Box>
  );
}

export default RefundUnavailableMessage;
